// const BASE_URL = `http://localhost:3000/api/v1`; // dev
const BASE_URL = `/api/v1`; // dev proxy

export const User = {
  current() {
    return fetch(`${BASE_URL}/users/current`, {
      credentials: "include",
    }).then((res) => res.json());
  },
  create(params) {
    return fetch(`${BASE_URL}/users`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    }).then((res) => res.json());
  },
};

//Sign In AJAX helper
export const Session = {
  create(params) {
    return fetch(`${BASE_URL}/session`, {
      method: "POST",
      credentials: "include", //need this for cookies to be allowed to be sent cross-origin
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    }).then((res) => res.json());
  },
  destroy() {
    return fetch(`${BASE_URL}/session`, {
      method: "DELETE",
      credentials: "include",
    }).then((res) => res.json());
  },
};

export const Client = {
   index({ page = 1, q = "" } = {}) {
    const params = new URLSearchParams({ page, q });
    return fetch(`${BASE_URL}/clients?${params.toString()}`, {
      credentials: "include",
    }).then((res) => res.json());
  },



  create(params) {
    return fetch(`${BASE_URL}/clients`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    }).then((res) => res.json());
  },

  show(id) {
    return fetch(`${BASE_URL}/clients/${id}`, { credentials: "include" }).then(
      (res) => res.json()
    );
  },

  update(id, params) {
    return fetch(`${BASE_URL}/clients/${id}`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    }).then((res) => res.json());
  },

    destroy(id) {
    return fetch(`/api/v1/clients/${id}`, {
      method: "DELETE",
      credentials: "include",
    }).then((res) => res.json());
  },
};

export const Baby = {
  create(client_id, params) {
    return fetch(`${BASE_URL}/clients/${client_id}/babies`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    }).then((res) => res.json());
  },

  update(id, params) {
    return fetch(`${BASE_URL}/babies/${id}`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    }).then((res) => res.json());
  },

  destroy(id) {
    return fetch(`${BASE_URL}/babies/${id}`, {
      method: "DELETE",
      credentials: "include",
    });
  },
};

export const Cohabitant = {
  create(client_id, params) {
    return fetch(`${BASE_URL}/clients/${client_id}/cohabitants`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    }).then((res) => res.json());
  },

  update(id, params) {
    return fetch(`${BASE_URL}/cohabitants/${id}`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    }).then((res) => res.json());
  },

  destroy(id) {
    return fetch(`${BASE_URL}/cohabitants/${id}`, {
      method: "DELETE",
      credentials: "include",
    });
  },
};

export const pickUp = {
  create(params) {
    return fetch(`${BASE_URL}/pick_ups`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    }).then((res) => res.json());
  },
  today() {
    return fetch(`${BASE_URL}/pick_ups/today`, {
      credentials: "include",
    }).then((res) => res.json());
  }
};
